import { h, Fragment } from "preact";

export default function ProductOptionAvailabilityTooltip({
  tooltip,
  variant,
  alignment = "left",
}) {
  const variantId = variant.id.replace("gid://shopify/ProductVariant/", "");
  const variantUrl = `${variant.product.helpers.url}?variant=${variantId}`;

  return (
    <>
      <info-tooltip
        class="product-options__availability-tooltip product-options__availability-tooltip--desktop"
        data-alignment={alignment}
      >
        <details class="product-options__availability-tooltip-details">
          <summary class="product-options__availability-tooltip-summary">
            <span class="visually-hidden">More info</span>
          </summary>
          <div className="rte--simple" data-content>
            <back-in-stock-button SELECTED-VARIANT={variantId} URL={variantUrl}>
              <button
                type="button"
                class="product-options__availability-tooltip-cta bis-button"
                data-bis-button
                dangerouslySetInnerHTML={{
                  __html: tooltip,
                }}
              ></button>
            </back-in-stock-button>
          </div>
        </details>
      </info-tooltip>
      <div className="product-options__availability-tooltip product-options__availability-tooltip--mobile">
        <div className="product-options__availability-tooltip-summary"></div>
        <span class="visually-hidden">
          {window.localeStrings.product.notify_me}
        </span>
      </div>
    </>
  );
}
